import React, { Component } from 'react';
import { connect } from 'react-redux';
import FilterButton from "../filterbutton/filterbutton.component";
import { monthNames } from "../../../SHARED/config/config";
import { getSoonInCinemaFilteredMovies } from '../../../SHARED/actions/movies.actions';
import { getSoonInCinemaFilters } from '../../../SHARED/actions/filters.actions';
import moment from 'moment';

class FiltersSoonInCinema extends Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedCheckbox: ''
        }
    }

    componentWillMount() {
        this.props.getSoonInCinemaFilters();
    }

    handleInteractivity = (value) => {
        this.setState({
            selectedCheckbox: value
        })
    };

    getFilters = () => {
        const markup = [];
        let first = null;

        this.props.soonInCinemaFilters.map((item, i) => {
            

            if(item['film_release_months'] !== '') {
                item['film_release_months'].map((it, j) => {
                    const month = it['film_release_month'];

                    if(i === 0 && j === 0) {
                        first = `${it['film_release_month_short']}`;
                    }

                    const unique = i + j + Math.random();
                    markup.push(
                        <FilterButton
                            key={unique} handleInteractivity={() => this.handleInteractivity(`${it['film_release_month_short']}`)}
                            interactivity={true}
                            appearance={'normal'}
                            label={month}
                            identifier={`${it['film_release_month_short']}`}
                            selectedValue={this.state.selectedCheckbox || first}
                        />
                    );
                    return markup
                });
            }
        });

        return markup;
    };

    filterContent = () => {
        this.props.getSoonInCinemaFilteredMovies(this.state.selectedCheckbox);

        //pass month to be used in a different component
        this.props.passMonth(this.state.selectedCheckbox);
    };

    render() {
        return (
            <div className="filters">
                <div className="filters-head">
                    DATA PREMIEREI
                </div>
                <div className="filters-content clearfix">
                    <div className="row no-gutters">
                        <div className="filters-head-text partial-border">FILTREAZĂ DUPĂ LUNĂ</div>
                        <div className="filters-buttons normal-checkboxes">
                            { this.getFilters() }
                        </div>

                        <div className="col-12 filter-area clearfix">
                            <div className="btn-cinemap-dark filter-movies" onClick={this.filterContent}>
                                FILTREAZĂ
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    soonInCinemaFilters: state.filters.soonInCinemaFilters,
});
export default connect(mapStateToProps, {getSoonInCinemaFilteredMovies, getSoonInCinemaFilters})(FiltersSoonInCinema);




// WEBPACK FOOTER //
// ./src/SHARED/components/filters/filterssoonincinema.component.js